import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import styles from "../../assets/styles/appointments.module.css"
import { FormGroup, InputAdornment, TextField } from '@mui/material';
import { SearchIcon } from '../../utils/functions/Icons';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../utils/store';
import { fetchCancelledAppReducer } from '../../utils/store/appointment/AppointmentSlice';
import Loader from '../common/Loader';
import NoDataFound from '../common/NoDataFound';
import { Images } from '../../utils/functions/Images';

export default function Cancelled() {
    const [searchValue, setSearchValue] = useState('')
    const { loading, CancelledAppointment, } = useSelector((state: RootState) => state.appointment)

    const dispatch = useDispatch<AppDispatch>()
    useEffect(() => {
        if (searchValue) {
            const cleanFunction = setTimeout(() => {
                dispatch(fetchCancelledAppReducer({ search: searchValue || '', id: 5 }));
            }, 1000);
            return () => clearTimeout(cleanFunction);
        } else {
            dispatch(fetchCancelledAppReducer({ search: searchValue || '', id: 5 }));
        }
    }, [searchValue]);
    return (
        <div>
            <div className={'md:w-1/2 w-full mb-6'}>
                <FormGroup className="customFormGroup">
                    <TextField
                        className={`custumTextField ${styles.InputStyle}`}
                        id="searchValue"
                        name="searchValue"
                        onChange={(e) => setSearchValue(e.target.value)}
                        value={searchValue}
                        placeholder='Search...'
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                </FormGroup>
            </div>
            {
                loading ? <Loader />
                    :
                    <TableContainer component={Paper} className='TableContainer'>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHead className='custumTableHead'>
                            <TableRow className={styles.completeTableRow}>
                                    <TableCell className='whitespace-nowrap'>Patient Name</TableCell>
                                    <TableCell align="right" className='whitespace-nowrap'>Appt. Date & Time</TableCell>
                                    <TableCell align="right" className='whitespace-nowrap'>Care Navigator</TableCell>
                                    <TableCell align="right" className='whitespace-nowrap'>Contact No.</TableCell>
                                </TableRow>
                            </TableHead>
                            {
                                CancelledAppointment?.length > 0 ?
                                    <TableBody>
                                        {
                                            CancelledAppointment?.map((item, index) => {
                                                return (
                                                    <TableRow
                                                    key={index}
                                                    className='custumTableRow'
                                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                                >
                                                    <TableCell component="th" scope="row">
                                                        <div className={styles.doctorSec}>
                                                            <img src={item?.profilePic ? item?.profilePic : Images.avtarIcon} alt="user icon" />
                                                            {item?.patientName}
                                                        </div>
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                       {item?.dateTime}
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                       {item?.careNavigatorName ? item?.careNavigatorName : 'N/A'}
                                                    </TableCell>
                                                    <TableCell component="th" scope="row">
                                                        {item?.phone}
                                                    </TableCell>
                                                </TableRow>
                                                )
                                            })
                                        }

                                    </TableBody>
                                    : <TableBody>
                                        <TableRow
                                            className='custumTableRow'
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" scope="row" colSpan={4}>
                                                <NoDataFound />
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                            }
                        </Table>
                    </TableContainer>
            }
        </div>
    );
}